/** Pagina iniziale: Impresa (predefinita) oppure Studio se era l'ultimo ambito usato. */
export const homePath = () => (localStorage.getItem("gromapp.ambito") === "studio" ? "/dashboard" : "/impresa");
